export default {
  APP: "/app",
  AUTH: "/auth",
  BOOKCASE_PRIVATE: "/bookcase",
  BOOKCASE_USER: "/bookcase-user",
  BOOKSTORES: "/bookstores",
  BOOKSTORES_ADMIN: "/bookstores-admin",
  COA: "/coa",
  COLLECTION: "/collection",
  COLLECTION_USER: "/collection-user",
  COVER_ID: "/cover-id",
  EDGECREATOR: "/edgecreator",
  EDGES: "/edges",
  EVENTS: "/events",
  FEEDBACK: "/feedback",
  GLOBAL_STATS: "/global-stats",
  GLOBAL_STATS_ADMIN: "/global-stats-admin",
  GLOBAL_STATS_USER: "/global-stats-user",
  PRESENTATION_TEXT: "/presentation-text",
  PUBLIC_COLLECTION: "/public-collection",
  STATS: "/stats",
  STORY_SEARCH: "/story-search",
};
